export const FONT_FAMILY = 'Roboto';

export const TypographyVariant = {
  h1: {
    fontFamily: FONT_FAMILY,
    fontSize: '6rem',
    lineHeight: 1.167,
    fontWeight: 300,
    letterSpacing: '-1.5px',
  },
  h2: {
    fontFamily: FONT_FAMILY,
    fontSize: '3.75rem',
    lineHeight: 1.12,
    fontWeight: 300,
    letterSpacing: '-0.5px',
  },
  h3: {
    fontFamily: FONT_FAMILY,
    fontSize: '3rem',
    lineHeight: 1.167,
    fontWeight: 400,
    letterSpacing: '0px',
  },
  h4: {
    fontFamily: FONT_FAMILY,
    fontSize: '2.125rem',
    lineHeight: 1.235,
    fontWeight: 400,
    letterSpacing: '0.25px',
  },

  h5: {
    fontFamily: FONT_FAMILY,
    fontSize: '1.5rem',
    lineHeight: 1.334,
    fontWeight: 400,
    letterSpacing: '0px',
  },
  h6: {
    fontFamily: FONT_FAMILY,
    fontSize: '1.25rem',
    lineHeight: 1.5,
    fontWeight: 500,
    letterSpacing: '0px',
  },

  subtitle1: {
    fontFamily: FONT_FAMILY,
    fontSize: '1rem',
    lineHeight: 1.75,
    fontWeight: 500,
    letterSpacing: '0.15px',
  },
  subtitle2: {
    fontFamily: FONT_FAMILY,
    fontSize: '0.875rem',
    lineHeight: 1.57,
    fontWeight: 500,
    letterSpacing: '0.1px',
  },
  body1: {
    fontFamily: FONT_FAMILY,
    fontSize: '1rem',
    lineHeight: 1.5,
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  body2: {
    fontFamily: FONT_FAMILY,
    fontSize: '0.875rem',
    lineHeight: 1.43,
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  caption: {
    fontFamily: FONT_FAMILY,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    fontWeight: 400,
    letterSpacing: '0.4px',
  },
  overline: {
    fontFamily: FONT_FAMILY,
    fontSize: '0.75rem',
    lineHeight: 2.66,
    fontWeight: 400,
    letterSpacing: '0.4px',
  },
};
